export function isDemoProcessing(eventType: number | null): boolean {
  return eventType !== null
}
